/**
 * Self-contained build-time feature flag for EW-003 Segment ARC FILLS
 * (dual-surface fill: the closed wedge <pattern> derived from the fill MODEL).
 *
 * WHY ITS OWN FILE (mirrors SegmentReactions/featureFlag.js, LinkedWheels/
 * featureFlag.js): kept local so this unit can be reviewed / merged independently
 * of the parallel media-library branches that also touch src/constants. Defaults
 * OFF; flipped per environment via REACT_APP_SEGMENT_ARC_FILLS.
 *
 * When OFF, createPie's wedge rendering is BYTE-IDENTICAL to today: the wedge
 * <pattern> is built from the legacy `d.data.pattern` URL exactly as before, and
 * the fill MODEL (`d.data.fill`) is never consulted. When ON, a segment that
 * carries a fill model renders its wedge via `toWedgePatternProps` (deck
 * userSpaceOnUse crop math), keeping the closed wedge and the open frame in sync
 * from ONE definition.
 *
 * Flag-name collision audit (backgroundPatterns/flag.js note): REACT_APP_SEGMENT_ARC_FILLS
 * is a new, unique name — no existing REACT_APP_* var uses the SEGMENT_ARC_FILLS token.
 *
 * At merge this can be folded into src/constants/featureFlags.js.
 */
const truthy = (v) => v === "true" || v === "1" || v === true;

export const SEGMENT_ARC_FILLS_ENABLED = truthy(
  process.env.REACT_APP_SEGMENT_ARC_FILLS
);
